// Note: the complete status list is stored in the database, so this is not intended
// to be a complete list. This list is only for specific statuses with display logic.
export enum eSigningAppointmentStatus {
  Requested = 'requested',
  Scheduled = 'scheduled',
  Complete = 'complete',
  Cancelled = 'cancelled',
  RescheduleRequired = 'reschedule-required',
  DocumentsShared = 'documents-shared',
}

export const terminalSigningStatuses: string[] = [eSigningAppointmentStatus.Cancelled, eSigningAppointmentStatus.Complete];
